import { configureStore } from "@reduxjs/toolkit";

import auth from "../features/auth/Slice";

// masters reducer
import location from "./location";

import master from "./master";

import settings from "../features/settings/Slice";

//dashboard
import dashboard from "./dashboard";

import common from "./common";

import usermanagement from "./usermanagement";

import subscription from "./subscription";

import property from "./property";

import expert from "./expert";

import contactus from "./contactus";

import aboutus from "./aboutus";

import customization from "./customization";

import rating_review from "./rating_review";

import leads from "./leads";

import rental from "./rental";

import getrental from "./getrental";

export const store = configureStore({
  reducer: {
    auth,
    location,
    master,
    dashboard,
    settings,
    common,
    usermanagement,
    subscription,
    property,
    expert,
    contactus,
    aboutus,
    customization,
    rating_review,
    leads,
    rental,
    getrental,
  },
});
